import { FunctionComponent } from 'react'
import styles from './planningKPI.module.scss'
import { CalendarEventType } from '@/types/Calendar.ts'
import Indicator from '@/components/_custom/Indicator/indicator.tsx'
import { useTranslation } from 'react-i18next'

interface StaffKPIProps {
    filterEvents: (filters: string[]) => void
    staffHoursInSection: number
    staffHoursNotInSection: number
    staffHoursHoliday: number
    staffHoursTraining: number
    isParent: boolean
}

const StaffKPI: FunctionComponent<StaffKPIProps> = ({
    filterEvents,
    staffHoursInSection,
    staffHoursNotInSection,
    staffHoursHoliday,
    staffHoursTraining,
    isParent
}: StaffKPIProps) => {
    const { t } = useTranslation()

    return (
        <>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.IN_SECTION])}>
                <Indicator
                    count={staffHoursInSection}
                    parent={isParent}
                    size={'m'}
                    text={`${staffHoursInSection > 1 ? t('hours') : t('hour')} ${t('inSection').toLowerCase()} `}
                    className={styles.Indicator}
                    badge={'inSection'}
                />
            </a>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.NOT_IN_SECTION])}>
                <Indicator
                    count={staffHoursNotInSection}
                    parent={isParent}
                    size={'m'}
                    text={`${staffHoursNotInSection > 1 ? t('hours') : t('hour')} ${t('notInSection').toLowerCase()} `}
                    className={styles.Indicator}
                    badge={'notInSection'}
                />
            </a>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.STAFF_HOLIDAY])}>
                <Indicator
                    count={staffHoursHoliday}
                    parent={isParent}
                    size={'m'}
                    text={`${staffHoursHoliday > 1 ? t('hours') : t('hour')} ${t('in')} ${t('holiday').toLowerCase()} `}
                    className={styles.Indicator}
                    badge={'staffHoliday'}
                />
            </a>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.STAFF_TRAINING])}>
                <Indicator
                    count={staffHoursTraining}
                    parent={isParent}
                    size={'m'}
                    text={`${
                        staffHoursTraining > 1 ? t('hours') : t('hour')
                    } ${t('in')} ${t('training').toLowerCase()} `}
                    className={styles.Indicator}
                    badge={'staffTraining'}
                />
            </a>
        </>
    )
}

export default StaffKPI
